import { Button, makeStyles } from '@fluentui/react-components';
import { useThemeContext } from '@theme/ThemeContext';
import { WeatherSunny32Filled, WeatherMoon20Filled, DarkThemeFilled } from '@fluentui/react-icons';

export const ThemeSelector = () => {
  const { themeName, setTheme } = useThemeContext();
  const styles = useStyles();

  const handleThemeChange = () => {
    switch (themeName) {
      case 'default':
        setTheme('dark');
        break;
      case 'dark':
        setTheme('contrast');
        break;
      case 'contrast':
        setTheme('default');
        break;
    }
  };

  return (
    <div className={styles.themeSelector}>
      <Button appearance="subtle" onClick={handleThemeChange} icon={getIcon(themeName)} />
    </div>
  );
};

const useStyles = makeStyles({
  themeSelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const getIcon = (themeName: string) => {
  switch (themeName) {
    case 'default':
      return <WeatherSunny32Filled />;
    case 'dark':
      return <WeatherMoon20Filled />;
    case 'contrast':
      return <DarkThemeFilled />;
  }
};
